export default "__VITE_ASSET__C$7_$GZA__"